<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateVentasConfirmarPago"
    >
      <header class="m-the-modal-header">
        <h5>CONFIRMAR PAGO</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p v-if="Object.values($modal.element.pago).length">
          Se confirmará
          <span
            v-if="$modal.element.pago.detalle === 'Contado'"
            class="text-transform-lowercase"
          >
            el pago de contado de
          </span>
          <span
            v-else-if="$modal.element.pago.detalle.includes('Cuota')"
            class="text-transform-lowercase"
          >
            el pago de la {{ $modal.element.pago.detalle }} de
          </span>
          <span
            v-else
            class="text-transform-lowercase"
          >
            el {{ $modal.element.pago.detalle }} de
          </span>
          <span class="font-weight-bold"> {{ $modal.element.pago.divisa }} {{ $modal.element.pago.monto.toFixed(2) }}</span>
          <span class="text-color-black-35"> {{ $modal.element.pago.divisa_iso_code }} </span>
          con {{ $modal.element.pago.medio_pago }}
        </p>
        <small class="font-weight-bold text-color-danger">
          Esta acción no podrá ser revertida.
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction cancel-text="CANCELAR"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMySalesModalConfirmPayment',
  data () {
    return {
      buttonPrimary: {
        action: 'Confirmar',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    updateVentasConfirmarPago () {
      this.buttonPrimary.sending = true
      this.$services.update('ventas', 'updateVentasConfirmarPago', null, [this.$route.params.subid ? this.$route.params.subid : this.$modal.element.invoice.venta, this.$modal.element.pago.id_pago ? this.$modal.element.pago.id_pago : this.$modal.element.invoice.pago])
        .then(response => {
          this.$alerts.pushAlert('mEditionBillingMySalesRecord', 'updateVentasConfirmarPago', 'success')
          this.$modal.updateData()
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionBillingMySalesRecord', 'updateVentasConfirmarPago', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
        })
    }
  }
}
</script>
